import { useCallback, useMemo } from 'react';

import { useHistory, useLocation } from 'react-router-dom';

interface UseSearchParamsReturn {
  searchParams: URLSearchParams;
  replaceSearchParams: (nextParams: URLSearchParams) => void;
}

export function useSearchParams(): UseSearchParamsReturn {
  const location = useLocation();
  const history = useHistory();

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const replaceSearchParams = useCallback(
    (nextParams: URLSearchParams): void => {
      history.replace({
        ...location,
        search: nextParams.toString(),
      });
    },
    [history, location],
  );

  return {
    searchParams,
    replaceSearchParams,
  };
}
